"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageChangeObserver = /** @class */ (function () {
    function PageChangeObserver(sessionManager) {
        var _this = this;
        this.destroy = function () {
            _this.observer.disconnect();
        };
        this.handleBodyChange = function () {
            var currentURL = window.location.pathname;
            if (_this.lastURL === currentURL)
                return;
            _this.lastURL = currentURL;
            _this.sessionManager.initSession();
            _this.firePageChangeEvent();
        };
        this.firePageChangeEvent = function () {
            var pageChanged = new CustomEvent('socital:pageChange');
            document.dispatchEvent(pageChanged);
        };
        this.lastURL = window.location.pathname;
        this.observer = new MutationObserver(this.handleBodyChange);
        this.sessionManager = sessionManager;
        this.observer.observe(document, {
            subtree: true,
            childList: true
        });
    }
    return PageChangeObserver;
}());
exports.default = PageChangeObserver;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnZUNoYW5nZU9ic2VydmVyLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvUGFnZUNoYW5nZU9ic2VydmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUE7SUFLSSw0QkFBWSxjQUE4QjtRQUExQyxpQkFTQztRQUVELFlBQU8sR0FBRztZQUNOLEtBQUksQ0FBQyxRQUFRLENBQUMsVUFBVSxFQUFFLENBQUE7UUFDOUIsQ0FBQyxDQUFBO1FBRU8scUJBQWdCLEdBQUc7WUFDdkIsSUFBTSxVQUFVLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUE7WUFDM0MsSUFBSSxLQUFJLENBQUMsT0FBTyxLQUFLLFVBQVU7Z0JBQUUsT0FBTTtZQUV2QyxLQUFJLENBQUMsT0FBTyxHQUFHLFVBQVUsQ0FBQTtZQUN6QixLQUFJLENBQUMsY0FBYyxDQUFDLFdBQVcsRUFBRSxDQUFBO1lBQ2pDLEtBQUksQ0FBQyxtQkFBbUIsRUFBRSxDQUFBO1FBQzlCLENBQUMsQ0FBQTtRQUVPLHdCQUFtQixHQUFHO1lBQzFCLElBQU0sV0FBVyxHQUFHLElBQUksV0FBVyxDQUFDLG9CQUFvQixDQUFDLENBQUE7WUFDekQsUUFBUSxDQUFDLGFBQWEsQ0FBQyxXQUFXLENBQUMsQ0FBQTtRQUN2QyxDQUFDLENBQUE7UUExQkcsSUFBSSxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQTtRQUN2QyxJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksZ0JBQWdCLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLENBQUE7UUFDM0QsSUFBSSxDQUFDLGNBQWMsR0FBRyxjQUFjLENBQUE7UUFFcEMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsUUFBUSxFQUFFO1lBQzVCLE9BQU8sRUFBRSxJQUFJO1lBQ2IsU0FBUyxFQUFFLElBQUk7U0FDbEIsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQW1CTCx5QkFBQztBQUFELENBQUMsQUFqQ0QsSUFpQ0MifQ==